// Barre d'annonce Black Friday - JavaScript vanilla

(function() {
  'use strict';

  // Configuration Black Friday
  const CONFIG = {
    enabled: true,
    interval: 5000, // 5 secondes
    announcements: [
      {
        id: 1,
        text: "BLACK FRIDAY : Jusqu'à -70% sur toute la collection",
        subtext: "Offres exceptionnelles - Ne manquez pas cette opportunité unique",
        link: "/products?promo=black-friday",
        highlight: "-70%",
        badge: "BLACK FRIDAY",
      },
      {
        id: 2,
        text: "BLACK FRIDAY : -50% sur les marques de luxe",
        subtext: "Nike, Adidas, Balenciaga, Louis Vuitton - Offres limitées",
        link: "/products?promo=black-friday",
        highlight: "-50%",
        badge: "BLACK FRIDAY",
      },
      {
        id: 3,
        text: "BLACK FRIDAY : Livraison GRATUITE dès 50€ d'achat",
        subtext: "Code: BF2024 - Valable uniquement pendant Black Friday",
        link: "/products?promo=black-friday",
        highlight: "GRATUITE",
        badge: "BLACK FRIDAY",
      },
      {
        id: 4,
        text: "BLACK FRIDAY : Nouveautés à -40% dès maintenant",
        subtext: "Dernières arrivées en promotion - Stock limité",
        link: "/products?promo=black-friday",
        highlight: "-40%",
        badge: "BLACK FRIDAY",
      },
    ]
  };

  // Icône SVG pour le badge (Zap/Flash)
  const ZAP_ICON = '<svg class="announcement-bar__badge-icon" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>';

  // Flèche SVG
  const ARROW_ICON = '<svg class="announcement-bar__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>';

  class AnnouncementBar {
    constructor(container, customConfig = null) {
      this.container = container;
      this.config = customConfig || CONFIG;
      this.currentIndex = 0;
      this.progress = 0;
      this.opacity = 1;
      this.progressInterval = null;
      this.changeInterval = null;
      this.init();
    }

    init() {
      if (!this.config || !this.config.enabled) {
        return;
      }
      
      if (!this.config.announcements || this.config.announcements.length === 0) {
        console.warn('No announcements configured');
        return;
      }

      this.createParticles();
      this.render();
      this.startAnimations();
    }

    createParticles() {
      const particlesContainer = this.container.querySelector('.announcement-bar__particles');
      if (!particlesContainer) return;

      // Créer plus de particules pour un effet plus visible
      const particleCount = 20;
      
      for (let i = 0; i < particleCount; i++) {
        const particle = document.createElement('div');
        particle.className = 'announcement-bar__particle';
        
        // Tailles variées : 1px, 1.5px, 2px, 2.5px
        const size = 1 + (i % 4) * 0.5;
        const floatDuration = 8 + (i % 4) * 3; // 8-11 secondes
        const twinkleDuration = 1.5 + (i % 3) * 0.5; // 1.5-2.5 secondes
        const delay = i * 0.2;
        
        // Distribution plus uniforme sur toute la largeur
        const leftPercent = 5 + ((i * 4.5) % 90);
        const topPercent = 20 + ((i * 3.5) % 60);
        
        particle.style.width = size + 'px';
        particle.style.height = size + 'px';
        particle.style.left = leftPercent + '%';
        particle.style.top = topPercent + '%';
        particle.style.animation = `float-gentle ${floatDuration}s ease-in-out infinite, twinkle-float ${twinkleDuration}s ease-in-out infinite`;
        particle.style.animationDelay = `${delay}s, ${delay * 0.3}s`;
        
        // Couleur selon le thème
        const theme = this.container.getAttribute('data-theme') || 'black-friday';
        particle.style.color = this.getParticleColor(theme);
        
        particlesContainer.appendChild(particle);
      }
    }

    getParticleColor(theme) {
      const colors = {
        'black-friday': '#facc15',
        'christmas': '#fca5a5',
        'spring': '#fb7185',
        'summer': '#67e8f9',
        'autumn': '#fdba74',
        'winter': '#67e8f9',
        'valentine': '#f9a8d4',
        'easter': '#a78bfa'
      };
      return colors[theme] || colors['black-friday'];
    }

    render() {
      const announcement = this.config.announcements[this.currentIndex];
      if (!announcement) return;

      const badgeText = this.config.badgeText || announcement.badge || 'BLACK FRIDAY';

      // Badge desktop
      const badgeDesktop = this.container.querySelector('.announcement-bar__badge--desktop');
      if (badgeDesktop) {
        badgeDesktop.innerHTML = ZAP_ICON + '<span class="announcement-bar__badge-text">' + badgeText + '</span>';
        badgeDesktop.style.opacity = this.opacity;
        badgeDesktop.style.transform = `scale(${this.opacity === 1 ? 1 : 0.95})`;
      }

      // Badge mobile
      const badgeMobile = this.container.querySelector('.announcement-bar__badge--mobile');
      if (badgeMobile) {
        const shortBadge = badgeText.length > 2 ? badgeText.substring(0, 2) : badgeText;
        badgeMobile.innerHTML = ZAP_ICON + '<span class="announcement-bar__badge-text">' + shortBadge + '</span>';
        badgeMobile.style.opacity = this.opacity;
      }

      // Texte principal
      const textElement = this.container.querySelector('.announcement-bar__text');
      if (textElement) {
        const parts = announcement.text.split(announcement.highlight);
        let html = '';
        for (let i = 0; i < parts.length; i++) {
          html += parts[i];
          if (i < parts.length - 1) {
            html += '<span class="announcement-bar__highlight">' + announcement.highlight + '</span>';
          }
        }
        textElement.innerHTML = html;
        // Ne pas appliquer l'opacity ici, elle sera gérée par les transitions CSS
      }

      // Sous-texte
      const subtextElement = this.container.querySelector('.announcement-bar__subtext');
      if (subtextElement && announcement.subtext) {
        subtextElement.textContent = announcement.subtext;
      }

      // Lien
      const linkElement = this.container.querySelector('.announcement-bar__link');
      if (linkElement) {
        linkElement.href = announcement.link;
      }

      // Flèche
      const arrowElement = this.container.querySelector('.announcement-bar__arrow');
      if (arrowElement) {
        arrowElement.style.opacity = this.opacity;
      }
    }

    updateProgress() {
      const progressBar = this.container.querySelector('.announcement-bar__progress-bar');
      const progressTrail = this.container.querySelector('.announcement-bar__progress-trail');
      const progressStar = this.container.querySelector('.announcement-bar__progress-star');
      const progressGlow = this.container.querySelector('.announcement-bar__progress-glow');
      const progressSparkles = this.container.querySelector('.announcement-bar__progress-sparkles');
      const progressFade = this.container.querySelector('.announcement-bar__progress-fade');

      // Animation continue en boucle (0-100% puis retour à 0)
      let displayProgress = this.progress;
      
      if (progressBar) {
        progressBar.style.width = displayProgress + '%';
      }
      if (progressTrail) {
        progressTrail.style.left = Math.max(0, displayProgress - 2) + '%';
      }
      if (progressStar) {
        progressStar.style.left = displayProgress + '%';
        // Effet de fade à l'arrière (disparaît quand on approche de 0%)
        const fadeOpacity = displayProgress < 10 ? displayProgress / 10 : 1;
        progressStar.style.opacity = fadeOpacity;
      }
      if (progressGlow) {
        progressGlow.style.left = displayProgress + '%';
        const fadeOpacity = displayProgress < 10 ? displayProgress / 10 : 1;
        progressGlow.style.opacity = fadeOpacity * 0.5;
      }
      if (progressSparkles) {
        progressSparkles.style.left = displayProgress + '%';
        const fadeOpacity = displayProgress < 10 ? displayProgress / 10 : 1;
        progressSparkles.style.opacity = fadeOpacity;
        this.createSparkles(progressSparkles);
      }
      if (progressFade) {
        // Effet de fade à gauche (disparaît progressivement)
        progressFade.style.left = Math.max(0, displayProgress - 15) + '%';
        progressFade.style.width = '20%';
        progressFade.style.opacity = displayProgress < 15 ? displayProgress / 15 : 1;
      }
    }

    createSparkles(container) {
      // Nettoyer les anciennes étincelles
      const existingSparkles = container.querySelectorAll('.announcement-bar__progress-sparkle');
      existingSparkles.forEach(sparkle => {
        if (sparkle.style.animationDelay === '0s') {
          sparkle.remove();
        }
      });

      // Créer 3 nouvelles étincelles
      for (let i = 0; i < 3; i++) {
        const sparkle = document.createElement('div');
        sparkle.className = 'announcement-bar__progress-sparkle';
        
        const angle = (i * 120) * (Math.PI / 180); // 120 degrés entre chaque
        const distance = 8 + (i * 2);
        const left = 50 + Math.cos(angle) * distance;
        const top = 50 + Math.sin(angle) * distance;
        
        sparkle.style.left = left + '%';
        sparkle.style.top = top + '%';
        sparkle.style.animationDelay = (i * 0.15) + 's';
        
        const theme = this.container.getAttribute('data-theme') || 'black-friday';
        sparkle.style.color = this.getParticleColor(theme);
        
        container.appendChild(sparkle);
        
        // Supprimer après l'animation
        setTimeout(() => {
          if (sparkle.parentNode) {
            sparkle.remove();
          }
        }, 800);
      }
    }

    startAnimations() {
      const intervalMs = this.config.interval;
      const progressStep = 100 / (intervalMs / 100);

      // Animation de progression continue (boucle infinie)
      this.progressInterval = setInterval(() => {
        this.progress += progressStep;
        if (this.progress >= 100) {
          this.progress = 0;
          // Changement de texte de manière fluide quand on atteint 100%
          this.changeAnnouncement();
        }
        this.updateProgress();
      }, 100);
    }

    changeAnnouncement() {
      // Transition ultra fluide sans coupure
      const textWrapper = this.container.querySelector('.announcement-bar__text-wrapper');
      const subtextElement = this.container.querySelector('.announcement-bar__subtext');
      
      if (textWrapper) {
        // Fade out très doux
        textWrapper.style.transition = 'opacity 0.6s ease-in-out, transform 0.6s ease-in-out';
        textWrapper.style.opacity = '0';
        textWrapper.style.transform = 'translateY(8px)';
      }
      
      if (subtextElement) {
        subtextElement.style.transition = 'opacity 0.6s ease-in-out';
        subtextElement.style.opacity = '0';
      }

      // Changer le contenu pendant le fade
      setTimeout(() => {
        this.currentIndex = (this.currentIndex + 1) % this.config.announcements.length;
        this.render();
        
        // Fade in très doux
        setTimeout(() => {
          if (textWrapper) {
            textWrapper.style.opacity = '1';
            textWrapper.style.transform = 'translateY(0)';
          }
          if (subtextElement) {
            subtextElement.style.opacity = '0.7';
          }
        }, 50);
      }, 300);
    }

    destroy() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
      }
      if (this.changeInterval) {
        clearInterval(this.changeInterval);
      }
    }
  }

  // Initialisation automatique quand le DOM est prêt
  function init() {
    // Sélectionner toutes les barres d'annonce avec data-theme
    const containers = document.querySelectorAll('.announcement-bar[data-theme]');
    if (containers.length === 0) return;
    
    containers.forEach(container => {
      // Lire la configuration depuis le script JSON
      const configId = container.getAttribute('data-config-id');
      let customConfig = null;
      
      if (configId) {
        const configScript = document.getElementById(configId);
        if (configScript && configScript.textContent) {
          try {
            const configData = JSON.parse(configScript.textContent.trim());
            if (configData && configData.announcements && configData.announcements.length > 0) {
              customConfig = {
                enabled: true,
                interval: configData.interval || 5000,
                announcements: configData.announcements,
                badgeText: configData.badgeText || 'BLACK FRIDAY'
              };
            }
          } catch (e) {
            console.warn('Erreur parsing announcement config:', e);
          }
        }
      }
      
      // Utiliser la config par défaut si aucune config personnalisée n'est trouvée
      if (!customConfig) {
        customConfig = CONFIG;
      }
      
      try {
        new AnnouncementBar(container, customConfig);
      } catch (e) {
        console.error('Erreur initialisation announcement bar:', e);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Export pour utilisation manuelle si nécessaire
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = AnnouncementBar;
  }
})();

